<template>
  <div class="container--fluid d-flex flex-column flex-md-row overflow-hidden" v-if="item">
    <Navbar/>

    <div class="flex-grow-1 overflow-hidden position-relative">
      <ItemPicturesCarousel :item="item"/>
      <div class="absolute left bottom fill-width pa-2">
        <v-card class="d-flex align-center justify-space-between py-3 px-4 border rounded" color="grey lighten-3"
                elevation="0">
          <span class="text--secondary">Buy on Credit</span>
          <v-switch :disabled="!credit" class="ma-0" dense hide-details inset v-model="buy_on_credit"></v-switch>
        </v-card>
      </div>
    </div>

    <v-sheet class="d-flex flex-column justify-center align-stretch flex-md-grow-1 ml-md-10 mt-0" color="white"
             style="z-index: 1">
      <div class="pa-6" style="box-shadow: 0 0 10px rgba(0, 0, 0, .1)">
        <v-chip class="percent-off px-3 mb-1" color="red" outlined small v-if="discount">{{ discount.percentage }}% off
          <span v-if="discount.end">, ends {{ discount.end | timeago }}</span>
        </v-chip>
        <div class="d-flex justify-space-between align-center">
          <div class="title font-weight-bold text--secondary"
               v-if="selected.monthly_amount_estimate || selected.monthly_amount">
            <small class="text-strikethrough grey--text" v-if="discount">
              {{ (item.credit_price || item.price) / item.no_of_months | currency }}
            </small>
            {{ (selected.monthly_amount_estimate || selected.monthly_amount) | currency }} / mo
            ({{ selected.no_of_months }} month{{ selected.no_of_months > 1 ? 's' : '' }})
          </div>
          <div class="title font-weight-medium text--secondary" v-else>
            <small class="text-strikethrough grey--text" v-if="discount">{{ item.price | currency }}</small>
            {{ selected.upfront_amount | currency }} outright
          </div>
          <div class="d-flex">
            <v-btn @click="addLike" icon>
              <v-badge :content="`${item.likes}`" color="grey" right>
                <v-icon color="red" v-if="liked">mdi-heart</v-icon>
                <v-icon v-else>mdi-heart-outline</v-icon>
              </v-badge>
            </v-btn>
            <v-btn @click="views = { ...views, reviews: true }" class="ml-1" icon>
              <v-badge :content="`${item.total_ratings}`" color="grey">
                <v-icon>mdi-comment-outline</v-icon>
              </v-badge>
            </v-btn>
          </div>
        </div>
        <div class="blue-grey--text font-weight-bold">{{ item.name }}</div>
        <v-rating :value="itemRating" background-color="orange lighten-3" color="orange" dense readonly
                  size="15"></v-rating>
        <v-alert class="text-body-2 ma-0 mt-3" dark dense rounded text type="info" v-if="buy_on_credit">
          Eligibility calculated at checkout
        </v-alert>
      </div>

      <v-divider v-if="$vuetify.breakpoint.smAndDown"></v-divider>

      <div class="d-flex pa-6">
        <v-bottom-sheet inset max-width="500" scrollable v-model="views.more">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" outlined v-on="on">More</v-btn>
          </template>
          <v-card class="pa-0" elevation="0">
            <v-card-text class="pa-0 pt-3">
              <ItemMore :item="item" @close="views.more = false"/>
            </v-card-text>
          </v-card>
        </v-bottom-sheet>

        <v-btn @click="views.quantity = true" class="flex-grow-1 ml-2 px-8" color="primary" dark elevation="0"
               v-if="item.quantity">
          Add to cart
        </v-btn>
        <v-chip class="ml-3 px-5" color="red" dark v-else>Out of stock</v-chip>
      </div>
    </v-sheet>

    <v-bottom-sheet inset max-width="420" v-model="views.quantity">
      <v-sheet class="d-flex flex-column justify-center align-stretch">
        <div class="px-6 pt-6 d-flex flex-row justify-space-between align-center">
          <p class="text-left text-title flex-grow-1 ma-0">How many items?</p>
          <v-text-field dense hide-details outlined readonly style="width: 80px" v-model="quantity">
            <v-icon @click="quantity > 1 ? quantity -= 1 : null" color="red" slot="prepend">mdi-minus</v-icon>
            <v-icon @click="quantity += 1" color="green" slot="append-outer">mdi-plus</v-icon>
          </v-text-field>
        </div>

        <template v-if="sizes.length">
          <v-divider class="my-5 fill-width"></v-divider>
          <div class="d-inline-flex align-center px-6">
            <v-radio-group class="ma-0" hide-details label="Size" row v-if="sizes && sizes.length"
                           v-model="variations.size">
              <v-radio :key="size" :label="size" :value="size" v-for="size in sizes"></v-radio>
            </v-radio-group>
          </div>
        </template>

        <v-divider class="my-5"></v-divider>
        <div class="d-flex justify-center px-6 pb-6">
          <v-btn @click="views = { ...views, quantity: false }" class="flex-grow-1" outlined>Back</v-btn>
          <v-btn @click="addToCart()" class="ml-2 px-8 flex-grow-1" color="primary" dark elevation="0">
            {{ credit ? 'Next' : 'Add to cart' }}
          </v-btn>
        </div>
      </v-sheet>
    </v-bottom-sheet>

    <v-bottom-sheet inset max-width="500" persistent scrollable v-model="views.reviews">
      <Reviews :itemId="item.id" @close="closeReview($event)"/>
    </v-bottom-sheet>

    <v-snackbar v-model="toast.visible" :color="toast.color || ''" bottom>
      {{ toast.message }}
    </v-snackbar>
  </div>
</template>

<script>
import ItemMore from "../ItemMore"
import ItemPicturesCarousel from "../ItemPicturesCarousel"
import Navbar from "../../nav/Navbar"
import Reviews from "../../Reviews"
import item from "../../../mixins/item";

export default {
  name: 'ItemMobile1',
  components: { ItemMore, ItemPicturesCarousel, Navbar, Reviews },
  mixins: [item],
  created() {
    this.applyWatchers();
    this.handleStateChange();
  },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/variables';

.container--fluid {
  height: calc((var(--vh, 1vh) * 100));
}
</style>
